import type {RegistrationRoute, RegistrationStatus} from './types';

const REGISTRATION_FORM_STEPS = new Set([
  'GeneralInfo',
  'UploadDocuments',
  'VendorInfo',
  'BankInfo',
  'KycFaceRecognition',
  'KycSendOtp',
  'SignContract',
  'Finish'
]);

const REGISTRATION_STATES = new Set(['PENDING', 'APPROVED', 'DECLINED', 'REJECTED']);

export const getRegistrationRoute = (status: RegistrationStatus): RegistrationRoute => {
  if (status.step === 'NotRegistered') {
    return '/user-register';
  }

  if (
    status.step === 'Register' ||
    status.step === 'WaitingForAdminApprove' ||
    status.step === 'KycIdentityInfo'
  ) {
    return '/vendor-register-overview';
  }

  if (
    status.step &&
    REGISTRATION_FORM_STEPS.has(status.step) &&
    REGISTRATION_STATES.has(status.state ?? '')
  ) {
    return '/vendor-register';
  }

  return '/vendor-register-overview';
};
